// this custom web component that adds or removes free sample based on cart subtotal and user selection, updating the cart dynamically( only one product can be added)
class CartFreeSample extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.cartAddFreeSample();
    }
    cartAddFreeSample() {
      fetch("/cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.text())
        .then((data) => {
          cartData(data);
        });
      function cartData(data) {
        let cartAjax = document.querySelector("cart-drawer#mini-cart");
        let cartSubtotal = data.total_price / 100;
        let cartSampleId = parseInt(cartAjax.getAttribute("data-free-sample-id"));
        let sampleThreshold = parseInt(
          cartAjax.getAttribute("data-free-sample-price")
        );
        const giftCheckboxes = document.querySelectorAll(
          'input[id^="free-product__"]'
        );
        giftCheckboxes.forEach(function (giftCheckbox) {
          giftCheckbox.addEventListener("change", function () {
            let isChecked = giftCheckbox.checked;
            const sampleId = giftCheckbox.getAttribute("data-sample-id");
            if (cartSubtotal >= sampleThreshold) {
              if (isChecked && !cartSampleId) {
                addToCart(sampleId);
                disableOtherSamples(sampleId);
              } else if (!isChecked && parseInt(sampleId)) {
                removeFreeSample(sampleId);
              } else if (isChecked && cartSampleId) {
                warningMessage();
              }
            }
          });
        });
        if (cartSampleId != NaN) {
          if (cartSubtotal < sampleThreshold) {
            removeFreeSample(cartSampleId);
          }
        }
      }
  
      function disableOtherSamples(selectedSampleId) {
        giftCheckboxes.forEach(function (giftCheckbox) {
          const sampleId = giftCheckbox.getAttribute("data-sample-id");
          const productWrapper = giftCheckbox.closest(
            ".freegift-product--wrapper"
          );
          if (sampleId !== selectedSampleId) {
            giftCheckbox.disabled = true;
          } else {
            giftCheckbox.disabled = false;
          }
        });
      }
      function addToCart(variantId) {
        let formData = {
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: { _freeSample: "true" },
            },
          ],
        };
  
        formData["sections"] = "mini-cart";
  
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error("Network response was not ok.");
            }
          })
          .then((data) => {
            if (document.querySelector(".header__cart-count")) {
              let CartCount = parseInt(
                document.querySelector(".header__cart-count").innerHTML
              );
              CartCount += 1;
              document.querySelector(".header__cart-count").innerHTML = CartCount;
            }
            let responseCart = data.sections;
            let miniCartSection = responseCart["mini-cart"];
            let tempDiv = document.createElement("div");
            tempDiv.innerHTML = miniCartSection;
            let miniCart = tempDiv.querySelector("#shopify-section-mini-cart");
            let oldCartDrawer = document.querySelector(
              "#shopify-section-mini-cart"
            );
            miniCart.querySelector("#mini-cart").setAttribute("open", "true");
            oldCartDrawer.innerHTML = miniCart.innerHTML;
            getFreeBeeToaster();
          })
          .catch((error) => console.error("Error:", error));
      }
      function removeFreeSample(sampleId) {
        const updates = { [sampleId]: 0 };
        const data = { updates, sections: "mini-cart" };
        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((data) => {
            let responseCart = data.sections;
            let miniCartSection = responseCart["mini-cart"];
            let tempDiv = document.createElement("div");
            tempDiv.innerHTML = miniCartSection;
            let miniCart = tempDiv.querySelector("#shopify-section-mini-cart");
            let oldCartDrawer = document.querySelector(
              "#shopify-section-mini-cart"
            );
            miniCart.querySelector("#mini-cart").setAttribute("open", "true");
            oldCartDrawer.innerHTML = miniCart.innerHTML;
            if (document.querySelector(".header__cart-count")) {
              let cartCount = parseInt(
                document.querySelector(".header__cart-count").innerHTML
              );
              cartCount -= 1;
              document.querySelector(".header__cart-count").innerHTML = cartCount;
            }
            REFRESH_CART();
          })
          .catch((error) => console.error("Error:", error));
      }
      function getFreeBeeToaster() {
        const giftToaster = document.querySelector(".free-gift-toaster");
        giftToaster.innerHTML = "Free Sample Added";
        giftToaster.setAttribute("open", "true");
  
        setTimeout(() => {
          hideToaster();
        }, 3000);
      }
      function warningMessage() {
        const giftToaster = document.querySelector(".free-gift-toaster");
        giftToaster.innerHTML = "You can't Add more than one product";
        giftToaster.setAttribute("open", "true");
  
        setTimeout(() => {
          hideToaster();
        }, 3000);
      }
  
      function hideToaster() {
        const giftToaster = document.querySelector(".free-gift-toaster");
        giftToaster.removeAttribute("open");
      }
    }
  }
  
  customElements.define("cart-free-sample", CartFreeSample);
  